import RsaDynamicAreaBody from "../index.js"

const routes = [
  {
    name: "RsaDynamicArea",
    path: "/rsaarea",
    component: RsaDynamicAreaBody.RsaDynamicBodyAreaPage,
    meta: { title: "R.S.A. - Area" },
  },
];

export default routes;
